module.exports = __webpack_public_path__ + "static/media/iNeedKart.4fe84d68.png";